import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const QualityControl = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Kalite Kontrol
      </Typography>
      <Paper sx={{ p: 2 }}>
        <Typography>Kalite kontrol burada görüntülenecek</Typography>
      </Paper>
    </Box>
  );
};

export default QualityControl;
